module.exports = __webpack_public_path__ + "img/15device.b3a162e6.png";